"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = require("../../styles/theme");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Li = (
/*#__PURE__*/
0, _styledBase.default)('li', {
  target: "eipg6l40",
  label: "Li"
})("border-top:1px solid ", _theme.colors.grey.secondary, ";&:first-of-type{border-top:0;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2NvbnRhaW5lcnMvZHJvcGRvd24vRHJvcGRvd25NZW51R3JvdXAuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU11QiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9jb250YWluZXJzL2Ryb3Bkb3duL0Ryb3Bkb3duTWVudUdyb3VwLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuXG5pbXBvcnQgeyBjb2xvcnMgfSBmcm9tICcuLi8uLi9zdHlsZXMvdGhlbWUnO1xuXG5jb25zdCBMaSA9IHN0eWxlZCgnbGknKWBcbiAgYm9yZGVyLXRvcDogMXB4IHNvbGlkICR7Y29sb3JzLmdyZXkuc2Vjb25kYXJ5fTtcbiAgJjpmaXJzdC1vZi10eXBlIHtcbiAgICBib3JkZXItdG9wOiAwO1xuICB9XG5gO1xuXG5jb25zdCBVbCA9IHN0eWxlZCgndWwnKWBcbiAgcGFkZGluZzogMDtcbmA7XG5cbmNvbnN0IERyb3Bkb3duTWVudUdyb3VwID0gKHsgY2hpbGRyZW4gfSkgPT4gKFxuICA8TGk+XG4gICAgPFVsPlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvVWw+XG4gIDwvTGk+XG4pO1xuXG5Ecm9wZG93bk1lbnVHcm91cC5wcm9wVHlwZXMgPSB7XG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMub25lT2ZUeXBlKFtcbiAgICBQcm9wVHlwZXMuYXJyYXlPZihQcm9wVHlwZXMubm9kZSksXG4gICAgUHJvcFR5cGVzLm5vZGVcbiAgXSkuaXNSZXF1aXJlZFxufTtcblxuZXhwb3J0IGRlZmF1bHQgRHJvcGRvd25NZW51R3JvdXA7XG4iXX0= */"));
var Ul = (
/*#__PURE__*/
0, _styledBase.default)('ul', {
  target: "eipg6l41",
  label: "Ul"
})(process.env.NODE_ENV === "production" ? {
  name: "y8aj3r",
  styles: "padding:0;"
} : {
  name: "y8aj3r",
  styles: "padding:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2NvbnRhaW5lcnMvZHJvcGRvd24vRHJvcGRvd25NZW51R3JvdXAuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWF1QiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9jb250YWluZXJzL2Ryb3Bkb3duL0Ryb3Bkb3duTWVudUdyb3VwLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuXG5pbXBvcnQgeyBjb2xvcnMgfSBmcm9tICcuLi8uLi9zdHlsZXMvdGhlbWUnO1xuXG5jb25zdCBMaSA9IHN0eWxlZCgnbGknKWBcbiAgYm9yZGVyLXRvcDogMXB4IHNvbGlkICR7Y29sb3JzLmdyZXkuc2Vjb25kYXJ5fTtcbiAgJjpmaXJzdC1vZi10eXBlIHtcbiAgICBib3JkZXItdG9wOiAwO1xuICB9XG5gO1xuXG5jb25zdCBVbCA9IHN0eWxlZCgndWwnKWBcbiAgcGFkZGluZzogMDtcbmA7XG5cbmNvbnN0IERyb3Bkb3duTWVudUdyb3VwID0gKHsgY2hpbGRyZW4gfSkgPT4gKFxuICA8TGk+XG4gICAgPFVsPlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvVWw+XG4gIDwvTGk+XG4pO1xuXG5Ecm9wZG93bk1lbnVHcm91cC5wcm9wVHlwZXMgPSB7XG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMub25lT2ZUeXBlKFtcbiAgICBQcm9wVHlwZXMuYXJyYXlPZihQcm9wVHlwZXMubm9kZSksXG4gICAgUHJvcFR5cGVzLm5vZGVcbiAgXSkuaXNSZXF1aXJlZFxufTtcblxuZXhwb3J0IGRlZmF1bHQgRHJvcGRvd25NZW51R3JvdXA7XG4iXX0= */"
});

var DropdownMenuGroup = function DropdownMenuGroup(_ref) {
  var children = _ref.children;
  return _react.default.createElement(Li, null, _react.default.createElement(Ul, null, children));
};

DropdownMenuGroup.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired
};
var _default = DropdownMenuGroup;
exports.default = _default;